export default function SkeletonModuleCard() {
  return (
    <div
      className="rounded-2xl overflow-hidden border-2 border-gray-200 bg-white animate-pulse"
      aria-hidden="true"
    >
      {/* Gradient header skeleton */}
      <div className="h-24 bg-gray-200" />
      {/* Body */}
      <div className="p-3 flex flex-col gap-2">
        <div className="h-4 bg-gray-200 rounded w-3/4" />
        <div className="h-3 bg-gray-200 rounded w-1/2" />
        <div className="flex justify-between">
          <div className="h-3 bg-gray-200 rounded w-1/3" />
          <div className="h-3 bg-gray-200 rounded w-1/4" />
        </div>
      </div>
    </div>
  );
}
